import React from "react";
import { IRoute } from "./interfaces/route.interface";

const RentalRequests = React.lazy(() =>  import("../pages/RentalRequestsPage"));

export const tenantRoutes:IRoute[] = [
    {
        path: "/tenant/rental-requests",
        exact: true,
        component: RentalRequests,
        privateRoute: true,
    }
];